export const SEARCH_PAGE_SIZE_DEFAULT = 20
const SEARCH_COMMON_PARAMS = { pagenum: 'pagenum', pagesize: 'pagesize' }
const SEARCH_TEXT_PARAMS = { text: 'text', limit: 'limit' }

export const SEARCH_BY_LOCATION_PARAMS = { lat: 'lat', lng: 'lng', distance: 'distance' }
export const SEARCH_WITHIN_FILTER_PARAMS = {
  reqParents: 'reqParents',
}
export const SEARCH_WITHIN_PARAMS = {
  primaryText: 'primaryText',
  reqParentsLabel: 'reqParentsLabel',
  reqParentsType: 'reqParentsType',
}
export const SEARCH_DATE_FILTER_PARAMS = { reqYears: 'reqYears' }

export const SEARCH_FILTER_PARAMS = {
  valType: 'valType',
  pubType: 'pubType',
  reqTypes: 'reqTypes',
  reqTypeGroups: 'reqTypeGroups',
  reqTypeLabel: 'reqTypeLabel',
  exact: 'exact',
}

export const SEARCH_DIRECTLY_WITHIN_FILTER_PARAMS = {
  reqDirParents: 'reqDirParents',
}

export const RADIUS_UI_PARAMS = {
  radiusUi: 'radiusUi',
}

export const SEARCH_PARAMS = {
  ...SEARCH_COMMON_PARAMS,
  ...SEARCH_TEXT_PARAMS,
  ...SEARCH_BY_LOCATION_PARAMS,
  ...SEARCH_WITHIN_FILTER_PARAMS,
  ...SEARCH_DATE_FILTER_PARAMS,
  ...SEARCH_FILTER_PARAMS,
  ...SEARCH_DIRECTLY_WITHIN_FILTER_PARAMS,
}
